import configs from "./production.json";
export default configs;
